import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

export interface SkeletonColumn {
    width: string;
    height?: string;
    appearance?: 'line' | 'circle' | 'square';
    className?: string;
    theme?: any;
}

@Component({
    selector: 'app-skeleton-list',
    standalone: true,
    imports: [CommonModule, NgxSkeletonLoaderModule],
    templateUrl: './skeleton-list.component.html',
    styleUrl: './skeleton-list.component.css'
})
export class SkeletonListComponent {
    @Input() columns: SkeletonColumn[] = [];
    @Input() rows: number = 10;

    getRowsArray() {
        return Array(this.rows).fill(0).map((x, i) => i);
    }

    getTheme(column: SkeletonColumn) {
        const theme: any = {
            'width': column.width,
            'height': column.height || '14px'
        };

        if (column.theme) {
            return { ...theme, ...column.theme };
        }

        return theme;
    }
}
